import React from 'react';
import { contactConfig, offerConfig } from '../data/siteConfig';
import { GuaranteeSeal } from './Shared';
export const GuaranteeSection = () => {
  const days = offerConfig.guaranteeDays;
  return <section className="bg-familia-dark py-12 md:py-16 px-4 md:px-6" data-id="element-104" data-mp="9ttiafim870r">
      <div className="max-w-3xl mx-auto w-full" data-id="element-105" data-mp="9wpgm4ydkxpq">
        <div className="bg-familia-darkCard border-2 border-familia-gold p-7 md:p-14 rounded-[2rem] md:rounded-[2.5rem] text-center" data-id="element-106" data-mp="euhbn7ubgzy5">
          <div className="flex justify-center mb-6 md:mb-8" data-id="element-107" data-mp="jqg1kzvamq0o">
            <GuaranteeSeal size="lg" data-id="element-108" data-mp="nt2p4okxlos2" />
          </div>
          <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-white mb-6 uppercase tracking-wide leading-tight" data-id="element-109" data-mp="skufay06dsho">
            Garantía de {days} días, sin preguntas
          </h2>
          <p className="text-body text-familia-onDarkMuted max-w-xl mx-auto mb-5" data-id="element-110" data-mp="12j0e36qoqiib">
            Descargalo, imprimilo y probalo durante {days} días. Si sentís que
            no te sirvió, mandanos un mail a{' '}
            <span className="font-semibold text-white" data-id="element-111" data-mp="25sggvb5nq1za">
              {contactConfig.supportEmail}
            </span>{' '}
            y te devolvemos el 100%. Sin explicaciones ni formularios.
          </p>
          <p className="text-[20px] md:text-2xl font-display font-bold text-familia-gold" data-id="element-112" data-mp="1vszcqy61zw5f">
            El riesgo lo corremos nosotros, no vos.
          </p>
        </div>
      </div>
    </section>;
};